import React, { useState } from 'react';
import config from 'hub-redux-auth/lib/shared/services/config';

export const OutletTableLoader = () => {
  const UI = config.get('uiv2', {})
  return (
    <div className='tw-flex tw-flex-col tw-gap-16'>
      <div className='tw-border-1 tw-border-gray-40 tw-p-16'>
        <UI.Skeleton />
      </div>
      <div className='tw-border-1 tw-border-gray-40 tw-p-16'>
        <UI.Skeleton />
      </div>
    </div>)
}

export const MerchantDetailCard = ({ mid, businessName, aclRoleName, logo, isMobile, onMasterDashSelect = () => { } }) => {
  const UI = config.get('uiv2', {})
  return (
    <div className={`tw-flex tw-flex-wrap tw-gap-16 tw-p-16 tw-border-1 gradiant-bg ${isMobile ? 'tw-rounded-b-8' : 'tw-rounded-8'} tw-border-gray-40 tw-bg-white`} style={isMobile ? { borderRadius: '0 0 16px 16px' } : {}}>
      <div className='tw-shrink-0 tw-w-72 tw-h-72 tw-rounded-1/2 tw-border-1 tw-flex tw-justify-center tw-items-center tw-border-gray-40'>
        {logo ? <img src={logo} /> : <UI.PayuIcon type='user-logo-filled' size='64px' color='#0C6150' />}
      </div>
      <div className='tw-flex tw-flex-col tw-gap-4'>
        <UI.Typography variant='SH2' weight='semi-bold' className='tw-text-green-800'>
          {businessName}
        </UI.Typography>
        <UI.Typography variant='SH4' className='tw-text-green-gray-300'>
          {mid}
        </UI.Typography>
        <UI.Typography variant='SH4' className='tw-text-green-gray-300'>
          {aclRoleName}
        </UI.Typography>
      </div>
      {!isMobile ? <UI.Button startIcon={{ type: 'tools' }} onClick={onMasterDashSelect} fullWidth>View Master Dash</UI.Button> : null}
    </div>
  )
}


export const OutletAccordion = ({
  title,
  address,
  children,
  haveChild,
  open,
  onClick = () => { },
  onMasterDashSelect = () => { },
}) => {
  const UI = config.get('uiv2', {})
  return (
    <div className={`tw-border-1 tw-border-${open ? 'green-100' : 'gray-40'} tw-bg-${open ? 'seablue-50' : 'white'} hover:tw-bg-seablue-50 hover:tw-border-green-100 tw-rounded-12`}>
      <div className='tw-flex tw-gap-8 tw-justify-between tw-cursor-pointer tw-p-16 group tw-flex-wrap' onClick={onClick}>
        <div className='tw-flex tw-gap-8 tw-shrink-0'>
          <div className='tw-flex tw-flex-col'>
            <UI.Typography variant='P1' className='tw-text-gray-800' weight='bold'>
              {title}
            </UI.Typography>
            <UI.Typography variant='SH4' weight='semi-bold' className='tw-text-gray-300'>
              {address}
            </UI.Typography>
          </div>
        </div>
        <div className='tw-flex tw-items-center'>
          {haveChild ? <>
            <UI.Button startIcon={{
              type: 'tools',
              size: '18px'
            }}
              variant='LINK'
              className={`group-hover:tw-flex tw-gap-4 ${open ? 'tw-flex' : 'tw-hidden'} tw-text-green-800 tw-shrink-0 tw-items-center`}
              onClick={onMasterDashSelect}
            >
              View Master Dash
            </UI.Button> <UI.PayuIcon type='down-arrow-grey' className={`tw-shrink-0 ${open ? 'tw-rotate-180' : ''}`} size='24px' />
          </> : null}
        </div>
      </div>
      {open ? <div className='tw-px-16 tw-pb-16'>{children}</div> : null}
    </div>
  )
}

export const TextCard = ({ text, onClick }) => {
  const UI = config.get('uiv2', {})

  return (
    <div className='tw-flex tw-justify-between tw-py-8 tw-px-16 tw-border-1 tw-border-green-100 tw-rounded-8 group tw-cursor-pointer tw-bg-white hover:tw-bg-seablue-50' onClick={onClick}>
      <UI.Typography variant='P1' className='tw-text-gray-800' weight='semi-bold'>
        {text}
      </UI.Typography>
      <div className='group-hover:tw-flex tw-w-24 tw-h-24 tw-hidden tw-justify-center tw-items-center tw-border-1 tw-border-gray-40 tw-rounded-1/2 tw-bg-white tw-text-seablue-800'>
        <UI.PayuIcon type='arrows_arrow-right' size='18px' />
      </div>
    </div>
  )
}

export const MOuletCard = ({ }) => {
  const UI = config.get('uiv2', {})

  return (
    <div className='tw-flex tw-flex-col tw-p-16 group tw-border-1 tw-border-gray-40 tw-rounded-8 hover:tw-bg-seablue-50 hover:tw-border-green-100 tw-relative tw-cursor-pointer'>
      <UI.Typography variant='P1' className='tw-text-gray-800' weight='bold'>
        Karol Bagh
      </UI.Typography>
      <UI.Typography variant='P1' className='tw-text-gray-800'>
        New Delhi, 521002
      </UI.Typography>
      <div className='tw-absolute tw-right-16 tw-rotate--90'>
        <UI.PayuIcon type='down-arrow-grey' />
      </div>
    </div>
  )
}